import {AddressAPI} from "../api/AddressAPI";
import {RsAddressCandidate} from "../api/dto/RsAddressCandidate";
import {RsExternalAddress} from "../api/dto/RsExternalAddress";

export class AddressService {

    private static instance: AddressService;
    private addressAPI: AddressAPI;

    private constructor() {
        this.addressAPI = new AddressAPI();
    }

    async search(query: string, verificationId: string): Promise<RsAddressCandidate[]> {
        return await this.addressAPI.search(query, verificationId)
    }

    async getExternalAddressById(id: number, verificationId: string): Promise<RsExternalAddress> {
        return await this.addressAPI.getExternalAddress(id, verificationId)
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new AddressService();
        }
        return this.instance;
    }

}